import JM from 'jalali-moment';
import { forwardRef } from 'react';
// @mui
import { Box, Button, Checkbox, Stack, TableCell, TableRow, Typography } from '@mui/material';
// components
import { MyAvatar } from 'src/components/common';
import Iconify from 'src/components/Iconify';
import Label from '../../../../components/Label';

// ----------------------------------------------------------------------

const FeedItemTableRow = forwardRef((props, ref) => {
  const { row, rowNumber, selected, onEditRow, onSelectRow, onDeleteRow, isDraggable, isDragging, ...rest } = props;

  const { FeedItemImageSrc, FeedItemSubject, FeedItemIsActive, FeedItemCreateDate, FeedItemPublishDate, FeedItemOrderIndex } = row;

  return (
    <TableRow
      hover
      selected={selected}
      ref={ref}
      {...rest}
      style={{
        width: '100%',
        background: isDragging ? '#f4f6f8' : '',
        ...rest.style,
      }}
    >
      <TableCell padding="checkbox">
        <div className="min-w-10">
          {isDraggable ? (
            <div className="flex justify-center items-center">
              <Iconify icon={'mdi:drag'} sx={{ width: '30px', height: '30px' }} />
            </div>
          ) : (
            <Checkbox checked={selected} onClick={onSelectRow} />
          )}
        </div>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell>
        <div className="flex items-center gap-1">
          <MyAvatar alt={FeedItemSubject} sx={{ mr: 2 }} src={FeedItemImageSrc} />

          <Stack>
            <Typography variant="body1" noWrap sx={{ fontSize: '13px', maxWidth: '150px' }}>
              {FeedItemSubject}
            </Typography>
          </Stack>
        </div>
      </TableCell>

      {/* <TableCell>
        <Typography variant="body1">{FeedItemSubjectSpecial}</Typography>
      </TableCell> */}

      <TableCell align="center">
        <Label variant={'ghost'} color={(FeedItemIsActive === 0 && 'error') || 'success'} sx={{ textTransform: 'capitalize' }}>
          {(FeedItemIsActive === 0 && 'غیرفعال') || 'فعال'}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{FeedItemOrderIndex}</Typography>
      </TableCell>

      {/* <TableCell align="center">
        <Typography variant="body1">{FeedItemTotalViewOnStart}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{FeedItemTotalClickOnStart}</Typography>
      </TableCell> */}

      {/* <TableCell align="center">{FeedItemContentDate}</TableCell> */}

      <TableCell align="center">{JM(FeedItemCreateDate).locale('fa').format('YYYY/MM/DD')}</TableCell>

      <TableCell align="center">{JM(FeedItemPublishDate).locale('fa').format('YYYY/MM/DD')}</TableCell>

      <TableCell align="right">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          <Button color="info" variant="contained" onClick={onEditRow}>
            ویرایش
          </Button>

          <Button color="error" variant="contained" onClick={onDeleteRow}>
            حذف
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
});

export default FeedItemTableRow;
